var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaoTaoNhanLucSo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "13 0 224 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fbdeb1;}.cls-3{fill:#fdbc42;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.54,
    y: 32.38,
    width: 187.87,
    height: 187.87
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0110\\xE0o_t\\u1EA1o",
    "data-name": "\\u0110\\xE0o t\\u1EA1o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-2",
    d: "M78.32,122.66a16,16,0,1,0,16,16A16,16,0,0,0,78.32,122.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110,186.82c0,14.71-14.19,15.74-31.69,15.74s-31.7-1-31.7-15.74,14.19-26.64,31.7-26.64S110,172.1,110,186.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    className: "cls-2",
    d: "M168.64,122.66a16,16,0,1,0,16,16A16,16,0,0,0,168.64,122.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.33,186.82c0,14.71-14.19,15.74-31.69,15.74s-31.69-1-31.69-15.74,14.19-26.64,31.69-26.64S200.33,172.1,200.33,186.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID-3",
    "data-name": "SVGID",
    className: "cls-3",
    d: "M123.48,109.5a18.6,18.6,0,1,0,18.59,18.6A18.6,18.6,0,0,0,123.48,109.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.39,184.23c0,17.13-16.53,18.33-36.91,18.33s-36.91-1.2-36.91-18.33,16.52-31,36.91-31S160.39,167.09,160.39,184.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_358_Basic_General_Gear_Wheel",
    "data-name": "358, Basic, General, Gear, Wheel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.47,59.46A11.41,11.41,0,1,1,112,70.87,11.51,11.51,0,0,1,123.47,59.46ZM129.63,71a6.16,6.16,0,0,0-12.31,0,6.16,6.16,0,1,0,12.31,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145.64,68.87v4.18a2,2,0,0,1-1.85,2l-3.16.18a16.56,16.56,0,0,1-1.94,4.61l2.11,2.44a2,2,0,0,1-.09,2.7l-3,3A2,2,0,0,1,135,88l-2.47-2.09a17,17,0,0,1-4.66,1.92L127.61,91a2,2,0,0,1-2,1.83h-4.22a2,2,0,0,1-2-1.83l-.26-3.22a16.47,16.47,0,0,1-4.67-1.92L112,88a2,2,0,0,1-2.73-.08l-3-3a2,2,0,0,1-.09-2.7l2.11-2.44a16.54,16.54,0,0,1-1.93-4.61L103.15,75a2,2,0,0,1-1.84-2V68.87a2,2,0,0,1,1.84-2l3.17-.26A16.5,16.5,0,0,1,108.26,62l-2.11-2.44a2,2,0,0,1,.08-2.7l3-3A2,2,0,0,1,112,53.8l2.46,2.09A16.75,16.75,0,0,1,119.08,54l.26-3.14a2,2,0,0,1,2-1.83h4.22a2,2,0,0,1,2,1.83l.26,3.14a16.69,16.69,0,0,1,4.66,1.91L135,53.8a2,2,0,0,1,2.72.09l3,3a2,2,0,0,1,.09,2.7L138.69,62a16.5,16.5,0,0,1,1.94,4.62l3.25.26A2,2,0,0,1,145.64,68.87ZM135,71a11.53,11.53,0,1,0-11.53,11.41A11.51,11.51,0,0,0,135,71Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaoTaoNhanLucSo);
export default __webpack_public_path__ + "static/media/dao_tao_nhan_luc_so.1fc4f6387f5c7baf36a40ff9edc9ac50.svg";
export { ForwardRef as ReactComponent };